import {
    typeExport
} from '../../../../../redux/store/type';
import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import ListDeadScreen from "../ListDeadScreen";
import store from "../../../../../redux/store";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashGetAllData.results.item_count,
    results: state.reducerListDeadScreen.results,
    NoInternetDialog: state.reducerListDeadScreen.NoInternetDialog,
    showLoading: state.reducerListDeadScreen.showLoading,
    lazyload_end: state.reducerListDeadScreen.lazyload_end,
    showRefresh: state.reducerListDeadScreen.showRefresh,
    failed: state.reducerListDeadScreen.failed,
    page: state.reducerListDeadScreen.page,
    empty: state.reducerListDeadScreen.empty,
    DataSplashScreen: state.reducerSplashGetAllData,
    resultsSet: state.reducerListDeadScreen.resultsSet,
    isLoadingSet: state.reducerListDeadScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListDeadScreen.NoInternetDialogSet,
    id: state.reducerListDeadScreen.id,
  //  isLoadingSetSubmitRequestScreen: state.reducerSubmitRequestScreen.isLoadingSet,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionError: (e, page) => dispatch(serviceActionError(e, page)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    let pagee;
    let url_send = "";


    switch (type) {
        case typeExport.TypeGetListDeadScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListDeadScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('searchall', params.searchall);
    formData.append('token', params.token == null ? '' : params.token);
    formData.append('page', params.page);
    formData.append('type', params.type);
    if (!params.searchall) {
        formData.append('todate', params.todate);
        formData.append('fromdate', params.fromdate);
        formData.append('fathername', params.fathername);
        formData.append('name', params.name);
        formData.append('family', params.family);

    }


    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        }
    };


    /*  axios(
          {
              // url: baseUrl + url + params,
              //url: url + "&after=0000-00-00",
              // url: url+`&${params.page}&${params.after}` ,
              url: url + params,
              // params:params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    axios.post(url, formData, config)
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetListDeadScreen:


                    if (response.data.success) {


                        let data = response.data.result;

                        // if (data == null) data = []
                        // let arr = store.getState().reducerListDeadScreen.results
                        // if (page == 1) {
                        //     arr = data
                        // } else {
                        //     if (arr.length > 0)
                        //     //    arr.push(data);
                        //         arr = [...arr, ...data]
                        //     else
                        //         arr = data
                        // }

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee));
                        }
                        // else {
                        //     page === 1 ? dispatch(serviceActionEmptyListDeadScreen(page)) : dispatch(serviceActionEndListDeadScreen(page));

                        // }
                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee)));
                        }


                        //    await AsyngStorageClass.setAsyng(global.IdCity  +typeExport.ListDead+ ((getState === null || getState === undefined || getState === '') ? id : global.typeCategory), arr)

                    } else {
                        dispatch(serviceActionError(response, page))
                    }

                    break;

                case typeExport.TypeSetListDeadScreen:
                    if (response.data.status)
                        dispatch(serviceActionSuccessSet(response.data, id))
                    else
                        dispatch(serviceActionError(response, page))
                    break;
                default:
            }
        }).catch((e) => {
        switch (type) {
            case typeExport.TypeGetListDeadScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListDeadScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //         if (isConnected) {

        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));

        //         }
        //     }

        //     );
        // }
        // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState,url, params, type, typeConnection, page,item_count);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     });
        // }

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             switch (type) {
        //                 case typeExport.TypeGetListDeadScreen:
        //                     dispatch(serviceActionError('error_Connection', page))
        //
        //                     break;
        //                 case typeExport.TypeSetListDeadScreen:
        //                     dispatch(serviceActionErrorSet('error_Connection'))
        //                     break;
        //                 default:
        //             }
        //         }
        //     }

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        } else {
            switch (type) {
                case typeExport.TypeGetListDeadScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListDeadScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListDeadScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListDeadScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListDeadScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListDeadScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListDeadScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListDeadScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1
})
export const serviceActionSuccess = (data, page) => ({

    type: typeExport.ListDeadScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.ListDeadScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListDeadScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListDeadScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListDeadScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListDeadScreen_SERVICE_AddSubList,

    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(ListDeadScreen);
